import { render, staticRenderFns } from "./RectangleH1Icon.vue?vue&type=template&id=5933cfa8&"
import script from "./RectangleH1Icon.vue?vue&type=script&lang=js&"
export * from "./RectangleH1Icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports